import { useRouter } from 'next/router';
import querystring from 'querystring';
import { useConfig } from 'shared/config/ConfigContext';
import useSWR from 'swr';
import type { LmsResult } from '@/interfaces/lms';

const fetcher = (url: string) => fetch(url).then((res) => res.json());

export const useLmsData = () => {
    const router = useRouter();
    const { apiUrlLMS } = useConfig();

    const params = querystring.stringify(router.query);
    const swrKey = `${apiUrlLMS}/offers${params.length ? `?${params}` : ''}`;

    const { data, error, isLoading } = useSWR<LmsResult>(swrKey, fetcher, {
        keepPreviousData: true,
        revalidateOnFocus: false,
        // revalidateOnMount: false,
    });

    return {
        data,
        error,
        isLoading,
    };
};
